import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { breakpoints, colors, opacities, theme } from '../../../design-system/systemprovider';
import { getIconUrl } from '../../../design-system/icon/utils';
import { formatPrice } from '../../common/utils';
import { RootState } from 'src/shared/store/rootReducer';
import {
  PAYPAL_EXPRESS_DESCRIPTION,
  PAYPAL_EXPRESS_FREE_DELIVERY,
  PAYPAL_EXPRESS_PRIVACY_POLICY,
  PAYPAL_EXPRESS_SUBTITLE,
  PAYPAL_EXPRESS_TITLE,
  PAYPAL_EXPRESS_THRESHOLD_DELIVERY,
  PAYPAL_EXPRESS_PRICE_DELIVERY_DESCRIPTION,
} from '../locale';
import { ShippingTypes } from '../../cart/types';
import { css } from '@emotion/core';
import { transitions } from '../../common/constants';

declare global {
  interface Window {
    dataLayer: {}[];
  }
}

export const PaypalECSInformations = () => {
  const { shipping_promo_amount: requiredAmountHome } = useSelector(
    (state: RootState) => state.cms.cart ?? 85
  );
  const { shippingTypes } = useSelector((state: RootState) => state.cart);
  const homeShippingPrice =
    shippingTypes.find((item) => item.label === ShippingTypes.HOME)?.amount ?? 4.9;

  return (
    <div
      css={css`
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      `}
    >
      <div
        css={css`
          padding: 40px 16px;

          @media (min-width: ${breakpoints.S}px) {
            padding: 32px;
          }
        `}
      >
        <div
          css={css`
            display: flex;
            justify-content: center;
          `}
        >
          <div
            css={css`
              font-size: ${theme.fontSizes.l};
              line-height: 110%;
              font-weight: 700;
              margin-right: ${theme.sizes.s};
              align-self: center;
            `}
          >
            {PAYPAL_EXPRESS_TITLE}
          </div>
          <img
            src={getIconUrl('paypalExpress')}
            css={css`
              width: 70px;
            `}
            alt="Logo Paypal"
          />
        </div>
        <div
          css={css`
            font-size: ${theme.fontSizes.s};
            font-weight: 700;
            line-height: 110%;
            margin-top: ${theme.sizes.xl};
          `}
        >
          {PAYPAL_EXPRESS_SUBTITLE}
        </div>
        <div
          css={css`
            font-size: ${theme.fontSizes.s};
            margin-top: ${theme.sizes.m};
            line-height: 110%;
            color: ${colors.GREY};
          `}
        >
          {PAYPAL_EXPRESS_DESCRIPTION}
        </div>
        {requiredAmountHome !== 0 && (
          <div
            css={css`
              font-size: ${theme.fontSizes.s};
              font-weight: 700;
              line-height: 110%;
              margin-top: ${theme.sizes.l};
              color: ${colors.GREY};
            `}
          >
            {PAYPAL_EXPRESS_THRESHOLD_DELIVERY}
          </div>
        )}

        <div
          css={css`
            font-size: ${theme.fontSizes.s};
            margin-top: ${theme.sizes.s};
            margin-bottom: ${theme.sizes.m};
          `}
        >
          {requiredAmountHome !== 0 && homeShippingPrice !== 0 ? (
            <span
              css={css`
                font-style: italic;
                line-height: 110%;
                color: ${colors.GREY};
              `}
            >
              {PAYPAL_EXPRESS_PRICE_DELIVERY_DESCRIPTION(
                formatPrice(homeShippingPrice).slice(0, -2),
                requiredAmountHome
              )}
            </span>
          ) : (
            <span
              css={css`
                color: #0d9560;
              `}
            >
              {PAYPAL_EXPRESS_FREE_DELIVERY}
            </span>
          )}
        </div>
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
          `}
        >
          <Link
            className="anchor-animated"
            to="/politique-de-confidentialite"
            data-testid="paypal-express-link-to-privacy-policy"
            target="_blank"
          >
            <div
              css={css`
                margin-top: ${theme.sizes.l};
                font-size: ${theme.fontSizes.xs};
                transition: ${transitions.GENERIC};

                @media (min-width: ${breakpoints.S}px) {
                  margin-top: ${theme.sizes.na};
                }

                @media (hover: hover) {
                  :hover {
                    cursor: pointer;
                    opacity: ${opacities.HOVERED};
                  }
                }
              `}
            >
              {PAYPAL_EXPRESS_PRIVACY_POLICY}
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};
